import { useContext, useState, useEffect } from "react";
import SondageReponseServices from "../services/sondageReponseServices";
import { AuthContext } from "../contexts/AuthContext";

const useSondageReponse = () => {
  const { api } = useContext(AuthContext);
  const service = new SondageReponseServices(api);

  const getAllSondageReponses = () => {
    return service.getAll();
  };

  const getOneSondageReponse = (id) => {
    return service.getOne(id);
  };

  const getReponseByUser = (idUser) => {
    return service.getReponseByUser(idUser);
  }; 

  const createSondageReponse = (reponse) => {
    return service.create(reponse);
  };

  const updateSondageReponse = (id, reponse) => {
    return service.update(id, reponse);
  };

  const deleteSondageReponse = (id) => {
    return service.delete(id);
  };

  const getSondageDashboard = () => {
    return service.getSondageDashboard();
  };

  return {
    getAllSondageReponses,
    getOneSondageReponse,
    getReponseByUser,
    getSondageDashboard,
    createSondageReponse,
    updateSondageReponse,
    deleteSondageReponse,
  };
};

export default useSondageReponse;
